import { Component, inject, OnInit } from '@angular/core';

import { FormControl, FormGroup, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NavbarComponent } from "../../../template/components/navbar/navbar.component";
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { GroupService } from '../../services/group.service';
import { finalize } from 'rxjs';
import { CreateGroup } from '../../models/group.model';
import { ToastService } from '../../../shared/services/toast.service';
import { LoadingButtonComponent } from "../../../shared/components/loading-button/loading-button.component";

type CreateGroupForm = {
  [K in keyof CreateGroup]: FormControl<CreateGroup[K]>;
};

@Component({
    selector: 'app-group-edit',
    imports: [ReactiveFormsModule, NavbarComponent, LoadingButtonComponent],
    templateUrl: './group-create.component.html'
})
export class GroupCreateComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly groupSrv = inject(GroupService);
  private readonly fb = inject(NonNullableFormBuilder);
  private readonly toastSrv = inject(ToastService);

  navList = [{ label: $localize`Lista Gruppi`, routePath: '/groups' }, { label:  $localize`'Nuovo Gruppo`, routePath: '/group/new' }];

  loading = false;

  groupForm: FormGroup = this.fb.group({
    name: ['', [Validators.required, Validators.maxLength(255)]],
    description: ['', Validators.maxLength(255)]
  });
  
  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      const id = params.get('id');
      if (id) {
        this.groupForm.patchValue({});
      }
    });
  }

  onSubmit() {
    if (this.groupForm.valid) {
      this.loading = true;
      console.log('Form Submitted', this.groupForm.value);
      this.groupSrv.createGroup(this.groupForm.getRawValue())
      .pipe(finalize(() => this.loading = false))
      .subscribe(
        {
          next: () => {
            this.toastSrv.show({ type: 'success', message:  $localize`'Gruppo creato` });
            this.router.navigate(['/groups']);
          }
       });
    }
  }

  onCancel() {
    this.groupForm.reset();
  }

  get name() { return this.groupForm.get('name'); }
  get description() { return this.groupForm.get('description'); }
}
